import styled from 'styled-components';

interface IContainerProps {
  widthPictureSummury?: string;
  heightPictureSummury?: string;
}

export const Container = styled.div<IContainerProps>`
  .containerDocument {
    display: flex;
    gap: 1rem;

    .documentPicture {
      border-radius: 0.5rem;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      max-width: 312px;
      max-height: 206px;
    }

    .contentDocument {
      .deletePicture {
        color: ${({ theme }) => theme.colors.error};
        border-radius: 1rem;
        padding: 0;
        min-width: 2rem;
        max-width: 2rem;

        svg {
          max-width: 1.2rem;
          max-height: 1.2rem;
          fill: ${({ theme }) => theme.colors.error};
        }
      }
    }
  }

  .containerUrlPicture {
    display: flex;
    align-items: flex-end;
    gap: 0.5rem;

    .profilePicture {
      border-radius: 100%;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      max-width: ${({ widthPictureSummury }) => widthPictureSummury || '12rem'};
      min-width: ${({ widthPictureSummury }) => widthPictureSummury || '12rem'};
      max-height: ${({ heightPictureSummury }) => heightPictureSummury || '12rem'};
      min-height: ${({ heightPictureSummury }) => heightPictureSummury || '12rem'};
    }

    .containerButton {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      button {
        color: ${({ theme }) => theme.colors.tertiary_500};
        border-radius: 1rem;
        padding: 0;
        min-width: 8rem;
        max-width: 8rem;
      }

      svg {
        max-width: 1rem;
        max-height: 1rem;
        fill: ${({ theme }) => theme.colors.tertiary_500};
        margin: 0 0.5rem;
      }
    }
  }

  @media (max-width: 370px) {
    .containerUrlPicture {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export const Content = styled.div`
  border-radius: 1rem;
  border: dashed ${({ theme }) => theme.colors.primary};
  background: #fbfbfb;
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: column;

  .uploadImgDoc {
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: column;
    padding: 1rem;

    .buttonDiv {
      margin: 0;
      display: flex;
      justify-content: center;

      .css-sl5xe1-MuiButtonBase-root-MuiButton-root {
        padding: 0px !important;
      }
    }

    p {
      width: auto;
      margin: 10px;
      color: ${({ theme }) => theme.colors.text};
    }

    :hover {
      cursor: pointer;
    }
  }
`;
